import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_site_icon = _resolveComponent("site-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    href: _ctx.url,
    title: _ctx.title,
    target: "_blank",
    style: {"text-decoration":"none"}
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_site_icon, { "social-site": _ctx.socialSite }, null, 8, ["social-site"])
      ]),
      (_ctx.tag === 'a')
        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["href", "title"]))
}